import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { navigationStore } from '../Stores'

/**
 * NavigationSync - Synchronizes React Router with MobX NavigationStore
 * This component must be rendered inside the BrowserRouter
 */
const NavigationSync: React.FC = () => {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    // Set the navigate function once
    navigationStore.setNavigate(navigate)
  }, [navigate])

  useEffect(() => {
    // Update location whenever it changes
    navigationStore.setLocation(location)
  }, [location])

  return null // This component doesn't render anything
}

export default NavigationSync
